import { create } from "zustand";
import api from "../../services/api.js";

const useOrdersStore = create((set) => ({
  orders: [],
  loading: false,
  error: null,

  getAllOrders: async () => {
    set({ loading: true, error: null });
    try {
      const response = await api.get("/orders");
      set({ orders: response.data, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },
}));

export default useOrdersStore;
